import React from "react";
import { Alert, Box } from "@mui/material";
import AppModal from "../common/AppModal";
import AppCircularProgress from "../common/AppCircularProgress";
import CloseShiftForm from "../../forms/CloseShiftForm";
import { ShiftResponseDto } from "../../shared/dtos/shift/ShiftResponseDto";

interface CloseShiftModalProps {
  open: boolean;
  onClose: () => void;
  currentShift: ShiftResponseDto | null;
  loadingData: boolean;
  loadingClose: boolean;
  error: string | null;
}

const CloseShiftModal: React.FC<CloseShiftModalProps> = ({
  open,
  onClose,
  currentShift,
  loadingData,
  loadingClose,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Close Shift & Z-Report"
    width="md"
    loading={loadingClose || loadingData}
  >
    {error && (
      <Alert severity="error" sx={{ mb: 2 }}>
        {error}
      </Alert>
    )}
    {loadingData ? (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <AppCircularProgress />
      </Box>
    ) : (
      <CloseShiftForm
        currentShift={currentShift}
        loading={loadingClose}
        error={error}
      />
    )}
  </AppModal>
);

export default CloseShiftModal;
